import { gql } from "@apollo/client";

export const SEND_REPORT_EMAIL = gql`
  query sendReportEmail(
    $userId: String,
    $to: [String], 
    $from: String,
    $subject: String,
    $text: String,
    $attachments: [Object]
  ) {
    sendReportEmail(
      userId: $userId,
      to: $to, 
      from: $from,
      subject: $subject,
      text: $text,
      attachments: $attachments
    )
  }
`;